import React from "react";

const OrderHistorySkeleton: React.FC = () => {
  return (
    <div className="max-md:border max-md:border-[#89D9EE] max-md:rounded-lg max-md:p-4">
      <div className="flex justify-between mb-3">
        <div className="skeleton h-6 !rounded w-40 max-sm:w-32 max-sm:h-5"></div>
        <div className="skeleton h-6 !rounded w-28 max-sm:w-20 max-sm:h-5"></div>
      </div>
      <div className="flex justify-end">
        <div className="skeleton h-6 !rounded w-60 max-sm:w-40 max-sm:h-5 max-sm:mb-2"></div>
      </div>
      {[1, 2, 3].map((val) => (
        <React.Fragment key={val}>
          <div className="mb-4">
            <div className="grid grid-cols-[80px_1fr] items-center gap-3 w-full">
              <div className="w-full object-cover skeleton !rounded-md relative h-28 max-sm:h-20 overflow-hidden" />
              <div className="w-full">
                <div className="flex flex-col gap-1">
                  <h6 className="w-40 max-sm:w-36 h-6 max-md:h-5 skeleton !rounded mr-2"></h6>

                  <h6 className="w-20 max-sm:w-16 h-5 max-md:h-5 skeleton !rounded"></h6>

                  <h6 className="w-36 max-sm:w-32 h-6 max-md:h-5 skeleton !rounded"></h6>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

// =======this is old order history page skeleton=======

// const OrderHistorySkeleton: React.FC = () => {
//   return (
//     <>
//       {[1, 2, 3].map((val) => (
//         <React.Fragment key={val}>
//           <div className="max-md:border max-md:border-[#89D9EE] max-md:rounded-lg max-md:mt-3 max-md:p-4">
//             <div className="grid grid-cols-[80px_1fr] max-sm:flex items-center gap-5 w-full">
//               <div className="w-full h-28 object-cover skeleton !rounded-md max-w-20 max-md:max-w-12 max-md:h-20" />
//               <div className="w-full">
//                 <div className="flex flex-col gap-1">
//                   <div className="flex items-center justify-between">
//                     <h6 className="w-40 h-7 max-md:h-5 skeleton !rounded-md max-md:!rounded mr-2"></h6>
//                     <h6 className="w-[10%] h-7 max-md:h-5 skeleton !rounded-md max-md:!rounded"></h6>
//                   </div>
//                   <h6 className="w-1/2 h-7 max-md:h-5 skeleton !rounded-md max-md:!rounded"></h6>
//                   <div className="flex items-center justify-between">
//                     <h6 className="w-52 h-7 max-md:h-5 skeleton !rounded-md max-md:!rounded"></h6>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="my-5 bg-no-repeat bg-contain bg-center bg-[url('@assets/images/ContactBorder.png')] w-full h-6 last:hidden max-md:hidden"></div>
//         </React.Fragment>
//       ))}
//     </>
//   );
// };

export default OrderHistorySkeleton;
